import { global } from ":shared/app";

export interface Get {
  props: never;
  returns: any;
}

const endpoint = "/teaming/leave-team";
export default {
  async get(): Promise<Get["returns"]> {
    return global.api.getAuth(endpoint).then((res) => {
      return res.data;
    });
  },
};
